<h3>Documentos que puedes crear</h3>
<div class="dashboard-counters">
  <ion-card>
    <ion-card-content>
      <div class="counter">{{ availableCredits() }}</div>
      <div class="label">Disponibles</div>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-content>
      <div class="counter">{{ promotionalCredits() }}</div>
      <div class="label">Promocionales</div>
      @if (promotionalCreditsExpireAt(); as expireAt) {
        <div class="expire-date">Válidos hasta {{ expireAt | dfnsFormat: 'P' }}</div>
      }
    </ion-card-content>
  </ion-card>
</div>
